// const API_URL = "http://192.168.1.22:8083";
// const API_URL = "http://127.0.0.1:5050";
const API_URL = "https://api.jeconsuite.com";

// const API_URL = "http://192.168.1.250:8083";

export default API_URL;

// Equipment drawing upload endpoint (single source of truth).
// Backend route: POST /upload/equipment_drawing  (multipart: files[], equipment_id)
// Authorized for Admin or Field Technicians in the Planning department.
export const EQUIPMENT_DRAWING_UPLOAD_ENDPOINT = "/api/upload/equipment_drawing";

// Equipment drawing lazy-load endpoints (single source of truth).
// Full drawing list for one equipment (metadata only):
export const equipmentDrawingsListPath = (equipmentId) =>
  `/api/equipment/${equipmentId}/drawings`;
// Short-lived (15 min) pre-signed S3 URL for a single drawing:
export const equipmentDrawingUrlPath = (fileId) =>
  `/api/equipment_drawing/${fileId}/url`;
// Server-rendered preview stream (used for TIFF -> PNG conversion):
export const equipmentDrawingPreviewPath = (fileId) =>
  `/api/equipment_drawing/${fileId}/preview`;
// Delete a single drawing (Admin or Planning Field Technician; audit-logged):
export const equipmentDrawingDeletePath = (fileId) =>
  `/api/equipment_drawing/${fileId}`;
// Rename a drawing's friendly display name (PATCH; same base path):
export const equipmentDrawingRenamePath = (fileId) =>
  `/api/equipment_drawing/${fileId}`;

// Equipment operational hold endpoints.
export const equipmentHoldPath = (equipmentId) =>
  `/api/equipment/${equipmentId}/hold`;
export const equipmentReleaseHoldPath = (equipmentId) =>
  `/api/equipment/${equipmentId}/release-hold`;
export const equipmentHoldHistoryPath = (equipmentId) =>
  `/api/equipment/${equipmentId}/hold-history`;

// External links
export const METHOD_STATEMENT_URL =
  "https://jeconeng-my.sharepoint.com/:f:/g/personal/sahil_parikh_jeconengineers_com/IgCjug6CKeJSSYPAp3bpA8stAYHW0NSM4YaX1o1_3Ss6NPQ?e=H4ihGC";
